<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part">day one</h2>
<h2 class="part1">A Happy Rural Seat of Various View</h2>
<p class="pbrk"></p>
<p class="img1"><img alt="images" src="images/day1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// d1.vue?cb1ce432